import React from 'react';

interface LoadingDotsProps {
  tone?: 'accent' | 'spark' | 'neutral';
  size?: number;
  style?: React.CSSProperties;
}

const LoadingDots: React.FC<LoadingDotsProps> = ({ tone = 'accent', size = 7, style }) => {
  const color =
    tone === 'spark' ? 'var(--accent-2)' :
    tone === 'neutral' ? 'var(--fg-3)' :
    'var(--accent)';

  const dot = (delay: number): React.CSSProperties => ({
    width: size,
    height: size,
    borderRadius: '50%',
    background: color,
    display: 'inline-block',
    animation: `cgPulse 1.2s ${delay}s infinite`,
    flexShrink: 0,
  });
  return (
    <span style={{ display: 'inline-flex', gap: Math.max(3, Math.round(size * 0.6)), alignItems: 'center', ...style }}>
      <span style={dot(0)} />
      <span style={dot(0.15)} />
      <span style={dot(0.3)} />
    </span>
  );
};

export default LoadingDots;
